import React from 'react';
import Chip from '@/app/components/chip';
import { t } from 'i18next';
import classNames from 'classnames';
import styles from '../styles.module.scss';

interface ChipSelectionProps<T extends string> {
  items: readonly T[];
  selectedItem?: T;
  selectedItems?: T[];
  onChange: (item: T) => void;
  isMultiSelect?: boolean;
  isIndustries?: boolean;
  isBig?: boolean;
}

/**
 * A reusable component for rendering chip selections
 * Supports both single and multi-select modes
 */
const ChipSelection = <T extends string>({
  items,
  selectedItem,
  selectedItems = [],
  onChange,
  isMultiSelect = false,
  isIndustries = false,
  isBig = false,
}: ChipSelectionProps<T>) => {

  const isItemSelected = (item: T) => {
    if (isMultiSelect) {
      return selectedItems.includes(item);
    }
    return selectedItem === item;
  };

  return (
    <div className={classNames(styles.chips, { [styles.industries]: isIndustries })}>
      {items.map((item, index) => (
        <Chip
          key={index}
          text={t(item)}
          isActive={isItemSelected(item)}
          isSecondaryWhite
          onClick={() => onChange(item)}
          isBig={isBig}
        />
      ))}
    </div>
  );
};

export default ChipSelection;